import React from "react";
import { Link } from 'react-router-dom';
import { Styled } from './styled';
import { StyledScreen } from "~common/screen";
import { BlueButton } from "~/components/pages/features/components/blue-button";
import CallbackIcon from '../../../../../images/features-page/marketing/callback.svg';
import AutoInformIcon from '../../../../../images/features-page/marketing/autoinform.svg';
import AutoCallIcon from '../../../../../images/features-page/marketing/autocall.svg';

const Marketing = () => {
  return (
    <Styled.Container>
      <Styled.Title>
        Повышение <StyledScreen.GreenText>конверсии</StyledScreen.GreenText>
      </Styled.Title>
      <Styled.WrapperBlock>
        <Styled.Block>
          <Styled.Line />
          <Styled.BlockContent>
            <CallbackIcon />
            <Styled.TitleBlock>Сallback</Styled.TitleBlock>
            <Styled.Text>Клиент может бесплатно позвонить прямо с сайта или оставить свой номер для перезвона.</Styled.Text>
            <Styled.Btn>
              <a href={'https://callback.onlinepbx.ru/'}>
                <BlueButton text={'Подробнее'}/>
              </a>
            </Styled.Btn>
          </Styled.BlockContent>
        </Styled.Block>
        <Styled.Block>
          <Styled.Line2 />
          <Styled.BlockContent>
            <AutoInformIcon />
            <Styled.TitleBlock>Автоинформатор</Styled.TitleBlock>
            <Styled.Text>Автоматически обзванивает клиентов по списку и воспроизводит голосовое сообщение.</Styled.Text>
            <Styled.Btn>
              <Link to={'/features/autoinformator'} >
                <BlueButton text={'Подробнее'}/>
              </Link>
            </Styled.Btn>
          </Styled.BlockContent>
        </Styled.Block>
        <Styled.Block>
          <Styled.Line3 />
          <Styled.BlockContent>
            <AutoCallIcon />
            <Styled.TitleBlock>Автоперезвон</Styled.TitleBlock>
            <Styled.Text>Модуль сам перезвонит клиенту и соединит его с первым освободившимся оператором.</Styled.Text>
            <Styled.Btn>
              <Link to={'/features/auto_call'} >
                <BlueButton text={'Подробнее'}/>
              </Link>
            </Styled.Btn>
          </Styled.BlockContent>
        </Styled.Block>
      </Styled.WrapperBlock>
      <Styled.TitleTextMobile>
        Оценка качества
      </Styled.TitleTextMobile>
      <Styled.WrapperBlockRating>
        <Styled.WrapperText>
          <Styled.TitleText>
            Оценка качества
          </Styled.TitleText>
          <Styled.Text>
            Оценка качества — это модуль, который после окончания разговора просит клиента оценить качество обслуживания от 1 до 5.
          </Styled.Text>
          <Styled.Text>
            <br/>
            Уведомление о плохой оценке сразу уходит на почту, а статистику по оценкам АТС собирает в отчет.
          </Styled.Text>
          <Styled.Button>
            <Link to={'/features/quality'} >
              <BlueButton text={'Подробнее'}/>
            </Link>
          </Styled.Button>
        </Styled.WrapperText>
        <Styled.Image src={process.env.PUBLIC_DIR + '/images/features-page/marketing/report-screen.svg'} alt={''}/>
      </Styled.WrapperBlockRating>
    </Styled.Container>
  )
}

export default Marketing
